export default __webpack_public_path__ + "images/cc4807158e5d1634e2a09b4a0c5a2ce8-relaxation_activities.svg";